import * as React from 'react';
import { doc } from './Hypervisor';
const useDocument = () => {
    const [data, setData] = React.useState({});
    const docApp = React.useMemo(() => doc(), []);
    React.useEffect(() => {
        const unsubscribe = docApp?.subscribe((docData) => setData(docData));
        return unsubscribe;
    }, [docApp]);
    return data;
};
export default useDocument;
